import { useEffect, useState } from "react";
import "../index.css";

export default function Admin() {
  const [productos, setProductos] = useState([]);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [usuario, setUsuario] = useState("");
  const [clave, setClave] = useState("");
  const [error, setError] = useState("");

  const API_BASE = "https://mardeolivosceuta.es/api";

  const handleLogin = async () => {
    try {
      const response = await fetch(`${API_BASE}/login.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ usuario, clave }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      if (data.success) {
        setIsLoggedIn(true);
        setError("");
      } else {
        setError("Credenciales incorrectas");
      }
    } catch (err) {
      console.error(err);
      setError("Error al conectar con el servidor");
    }
  };




  useEffect(() => {
    if (isLoggedIn) {
      fetch(`${API_BASE}/get_productos.php`)
        .then((res) => {
          if (!res.ok) {
            throw new Error(`HTTP error! status: ${res.status}`);
          }
          return res.json();
        })
        .then((data) => {
          setProductos(data);
        })
        .catch((error) => {
          console.error("Error al obtener productos:", error);
        });
    }
  }, [isLoggedIn]);

  const cambiarDisponibilidad = async (id, estadoActual) => {
    const nuevoEstado = estadoActual === 1 ? 0 : 1;
    try {
      const response = await fetch(`${API_BASE}/cambiar_disponibilidad.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ id, disponible: nuevoEstado }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      // Opcional: validar respuesta PHP si retorna éxito
      /* const result = await response.json();
      if (!result.success) {
        throw new Error('No se pudo cambiar disponibilidad');
      } */

      setProductos((prev) =>
        prev.map((p) => (p.id === id ? { ...p, disponible: nuevoEstado } : p))
      );
    } catch (error) {
      console.error("Error al cambiar disponibilidad:", error);
    }
  };

  if (!isLoggedIn) {
    return (
      <main style={{ padding: "40px", textAlign: "center" }}>
        <h1 style={{ marginBottom: "20px" }}>Acceso restringido</h1>
        <input
          type="text"
          value={usuario}
          onChange={(e) => setUsuario(e.target.value)}
          placeholder="Usuario"
          style={{
            padding: "10px",
            borderRadius: "8px",
            border: "1px solid #ccc",
            width: "250px",
            marginBottom: "10px",
          }}
        />
        <br />
        <input
          type="password"
          value={clave}
          onChange={(e) => setClave(e.target.value)}
          placeholder="Contraseña"
          style={{
            padding: "10px",
            borderRadius: "8px",
            border: "1px solid #ccc",
            width: "250px",
            marginBottom: "10px",
          }}
        />
        <br />
        <button
          onClick={handleLogin}
          style={{
            padding: "10px 20px",
            borderRadius: "8px",
            backgroundColor: "#503a2c",
            color: "white",
            border: "none",
            cursor: "pointer",
          }}
        >
          Entrar
        </button>

        <br />

        <div>
          Si no te acuerda de la contraseña avisa a Juan Carlos no pasa na'
        </div>
        {error && <p style={{ color: "red", marginTop: "10px" }}>{error}</p>}
      </main>
    );
  }

  return (
    <main
      className="admin-panel"
      style={{ padding: "20px", maxWidth: "800px", margin: "auto" }}
    >
      <h1 style={{ textAlign: "center", marginBottom: "30px" }}>
        Panel de Administración
      </h1>

      {productos.map((producto) => (
        <section
          key={producto.id}
          style={{
            display: "flex",
            alignItems: "center",
            gap: "16px",
            padding: "16px",
            marginBottom: "20px",
            backgroundColor: "#f7f7f7",
            borderRadius: "12px",
            boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
          }}
        >
          <img
            src={producto.imagen}
            alt={producto.nombre}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = "img/plato.jpeg";
            }}
            style={{
              width: "100px",
              height: "100px",
              borderRadius: "10px",
              objectFit: "cover",
            }}
          />
          <div style={{ flex: 1 }}>
            <h2>{producto.nombre}</h2>
            <p style={{ margin: "4px 0" }}>{producto.precio}€</p>
            <p style={{ margin: "4px 0" }}>{producto.descripcion}</p>
            <p style={{ fontStyle: "italic", color: "#666" }}>
              {producto.alergenos}
            </p>
          </div>
          <button
            onClick={() =>
              cambiarDisponibilidad(producto.id, producto.disponible)
            }
            style={{
              backgroundColor: producto.disponible ? "#4CAF50" : "#f44336",
              color: "white",
              padding: "8px 14px",
              border: "none",
              borderRadius: "6px",
              cursor: "pointer",
              whiteSpace: "nowrap",
            }}
          >
            {producto.disponible ? "Disponible" : "No disponible"}
          </button>
        </section>
      ))}
    </main>
  );
}
